import apolloProvider from '@/libs/vue-apollo'
import queries from './queries'
import mutations from './mutations'

export default {
  // Board queries
  getProjectBoards(data) {
    return apolloProvider.query({
      query: queries.GET_PROJECT_BOARDS,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },

  getBoard(data) {
    return apolloProvider.query({
      query: queries.GET_BOARD,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },

  getBoardTasks(data) {
    return apolloProvider.query({
      query: queries.GET_BOARD_TASKS,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },

  // Board mutations
  createBoard(data) {
    return apolloProvider.mutate({
      mutation: mutations.CREATE_BOARD,
      variables: { ...data },
    })
  },

  updateBoard(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_BOARD,
      variables: { ...data },
    })
  },

  deleteBoard(data) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_BOARD,
      variables: { ...data },
    })
  },

  addBoardMember(data) {
    return apolloProvider.mutate({
      mutation: mutations.ADD_BOARD_MEMBER,
      variables: { ...data },
    })
  },

  removeBoardMember(data) {
    return apolloProvider.mutate({
      mutation: mutations.REMOVE_BOARD_MEMBER,
      variables: { ...data },
    })
  },

  // Task Status mutations
  createTaskStatus(data) {
    return apolloProvider.mutate({
      mutation: mutations.CREATE_TASK_STATUS,
      variables: { ...data },
    })
  },

  updateTaskStatus(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_TASK_STATUS,
      variables: { ...data },
    })
  },

  deleteTaskStatus(id, reassignStatusId = null) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_TASK_STATUS,
      variables: { id, reassignStatusId },
    })
  },

  // Task queries

  fetchTask(data) {
    return apolloProvider.query({
      query: queries.FETCH_TASK,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  // Task mutations
  createTask(data) {
    return apolloProvider.mutate({
      mutation: mutations.CREATE_TASK,
      variables: { ...data },
    })
  },

  updateTask(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_TASK,
      variables: { ...data },
    })
  },

  moveTask(data) {
    return apolloProvider.mutate({
      mutation: mutations.MOVE_TASK,
      variables: { ...data },
    })
  },

  deleteTask(uuid) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_TASK,
      variables: { uuid },
    })
  },

  uploadTaskAsset(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPLOAD_TASK_ASSET,
      variables: { ...data },
    })
  },

  deleteTaskAsset(uuid) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_TASK_ASSET,
      variables: { uuid },
    })
  },

  assignTask(data) {
    return apolloProvider.mutate({
      mutation: mutations.ASSIGN_TASK,
      variables: { ...data },
    })
  },
  createBoardLabel(data) {
    return apolloProvider.mutate({
      mutation: mutations.CREATE_BOARD_LABEL,
      variables: { ...data },
    })
  },
  updateBoardLabel(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_BOARD_LABEL,
      variables: { ...data },
    })
  },
  deleteBoardLabel(data) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_BOARD_LABEL,
      variables: { ...data },
    })
  },
  fetchBoardLabels(boardUid) {
    return apolloProvider.query({
      query: queries.GET_BOARD_LABELS,
      variables: { boardUid },
      fetchPolicy: 'no-cache',
    })
  },
  createMilestone(data) {
    return apolloProvider.mutate({
      mutation: mutations.CREATE_MILESTONE,
      variables: { ...data },
    })
  },
  updateMilestone(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_MILESTONE,
      variables: { ...data },
    })
  },
  deleteMilestone(data) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_MILESTONE,
      variables: { ...data },
    })
  },
  getTasksByStatusKey(data) {
    return apolloProvider.query({
      query: queries.GET_TASKS_BY_STATUS_KEY,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  attachTemporaryAsset(data) {
    return apolloProvider.mutate({
      mutation: mutations.ATTACH_TEMPORARY_ASSET,
      variables: { ...data },
    })
  },
  addTaskComment(data) {
    return apolloProvider.mutate({
      mutation: mutations.ADD_TASK_COMMENT,
      variables: { ...data },
    })
  },
  updateTaskComment(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPDATE_TASK_COMMENT,
      variables: { ...data },
    })
  },
  deleteTaskComment(data) {
    return apolloProvider.mutate({
      mutation: mutations.DELETE_TASK_COMMENT,
      variables: { ...data },
    })
  },
  getMemberPerformance(data) {
    return apolloProvider.query({
      query: queries.GET_MEMBER_PERFORMANCE,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  getTeamPerformance(data) {
    return apolloProvider.query({
      query: queries.GET_TEAM_PERFORMANCE,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  getBoardPerformance(data) {
    return apolloProvider.query({
      query: queries.GET_BOARD_PERFORMANCE,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  getTeamAndBoardPerformance(data) {
    return apolloProvider.query({
      query: queries.GET_TEAM_AND_BOARD_PERFORMANCE,
      variables: { ...data },
      fetchPolicy: 'no-cache',
    })
  },
  attachTemporaryCommentAsset(data) {
    return apolloProvider.mutate({
      mutation: mutations.ATTACH_TEMPORARY_COMMENT_ASSET,
      variables: { ...data },
    })
  },
  uploadCommentAsset(data) {
    return apolloProvider.mutate({
      mutation: mutations.UPLOAD_COMMENT_ASSET,
      variables: { ...data },
    })
  },
}
